module.exports = __webpack_public_path__ + "static/media/ts6tj0.96cbd822.png";